import { useContext, useEffect } from 'react'

import { Box, DoughnutChart, Text } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { ProvidersContext } from '../../providers.context'
import { ProviderCard } from '../ProviderCard/providers-card.comp'

import * as Styles from './providers-cards.styles'
export const ProviderCards = () => {
  const {
    providersCount,
    activeProviders,
    inactiveProviders,
    riskProviders,
    providersWithInvoices,
    actions,
  } = useContext(ProvidersContext)

  const theme = useTheme()

  useEffect(() => {
    actions.getProvidersStatistics()
  }, [])

  return providersCount ? (
    <Box
      width="100%"
      borderRadius={theme.border_radius.table}
      boxShadow={theme.box_shadow.card}
      backgroundColor={theme.colors.custom.white}
      padding={3}
      gap={2}
      flexWrap="wrap"
      alignItems="stretch"
    >
      <Box
        boxShadow={theme.box_shadow.card}
        borderRadius={theme.border_radius.card}
        border={{
          width: 1,
          color: 'grey_5',
        }}
        padding={3}
        gap={2}
        alignItems="stretch"
        justifyContent="center"
        flex={1}
        flexWrap="wrap"
        maxWidth="370px"
      >
        <DoughnutChart
          size={90}
          totalValue={providersCount}
          parts={[
            { value: activeProviders, color: theme.colors.primary },
            { value: inactiveProviders, color: theme.colors.secondary },
          ]}
          fontSize="20px"
        />
        <Box direction="column" justifyContent="center">
          <Box alignItems="center" gap={1}>
            <Box
              borderRadius="50%"
              backgroundColor="primary"
              height="8px"
              width="8px"
            />
            <Text size="small">Fornecedores ativos</Text>
            <Text size="medium" fontWeight={500}>
              {activeProviders}
            </Text>
          </Box>

          <Box alignItems="center" gap={1}>
            <Box
              borderRadius="50%"
              backgroundColor="secondary"
              height="8px"
              width="8px"
            />
            <Text size="small">Fornecedores inativos</Text>
            <Text fontWeight={500} size="medium">
              {inactiveProviders}
            </Text>
          </Box>
        </Box>
      </Box>

      <ProviderCard
        color="purple"
        icon="receipt"
        title="Fornecedores com NFs"
        value={providersWithInvoices}
      />
      <Styles.Link
        href="#providerTable"
        onClick={() => {
          actions.setCheckboxRisksFilter(true)
        }}
      >
        <ProviderCard
          color="warning"
          title="Riscos Socioambientais"
          value={riskProviders}
        />
      </Styles.Link>
    </Box>
  ) : null
}
